import { genarateAnswersCorrect } from 'app/utils/test';
import * as testConst from 'app/constants/tests';
import { AppStoreState } from 'app/redux/store';
import { useSelector } from 'react-redux';
import { Question } from 'types/test';

interface ResultDisplayProps {
  questionResult: Question | null;
  groupType: number;
}

const ResultDisplay = (props: ResultDisplayProps) => {
  const { process } = useSelector((state: AppStoreState) => state.test);
  const { groupType, questionResult } = props;

  if (groupType === testConst.QUESTION_RADIO || !questionResult || process !== 'complete') {
    return null;
  }

  let formattedResult = questionResult?.result?.replaceAll('$$', ', ') || '';
  if (groupType === testConst.QUESTION_INPUT) {
    formattedResult = genarateAnswersCorrect(questionResult?.result).join('/');
  }

  return (
    <span className='text-info mt-1 ml-2'>{formattedResult}</span>
  );
};

export default ResultDisplay;
